var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('implantacao-list',{attrs:{"colunas":_vm.colunasListagem,"carregar":_vm.carregar,"filtros":_vm.filtrosPrincipais,"novo":_vm.novo,"filtrar-por-ativo":"","mostrar-remover-lote":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }